export default "__VITE_ASSET__e433a8f5__"